import { API } from 'aws-amplify';
import {
    REACT_APP_BASE_KEY,
    REACT_APP_BASE_NAME,
    REACT_APP_CLIENT_NAME,
} from '../config/settings/environments';

/**
 * To get the trucks.
 */
export const getTrucks = async () => {
    const paths = {
        talabre: '/v1/get-trucks',
    };
    let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-trucks';

    const response = await API.get(REACT_APP_BASE_NAME, path, {
        headers: { 'x-api-key': REACT_APP_BASE_KEY },
        response: true,
    });

    return {
        data: response.data,
        headers: response.headers,
        request: response.config,
        status: response.status,
    };
};

/**
 * To get the cycles.
 */
export const getCycles = async ({ year, month, day, turno }) => {
    const paths = {
        talabre: '/v1/get-cycles',
    };
    let path = paths[REACT_APP_CLIENT_NAME] || '/v1/get-cycles';
    if (year && month && day && turno) {
        path = `${path}?year=${year}&month=${month}&day=${day}&turno=${turno}`;
    }

    const response = await API.get(REACT_APP_BASE_NAME, path, {
        headers: { 'x-api-key': REACT_APP_BASE_KEY },
        response: true,
    });

    return {
        data: response.data,
        headers: response.headers,
        request: response.config,
        status: response.status,
    };
};